import { motion } from 'framer-motion';

const steps = [
  {
    num: '01',
    title: 'Clarify the Vision',
    body: 'We listen. You share what you\u2019re building, what\u2019s stuck, or what you\u2019re imagining. We ask the right questions to find the real opportunity.',
  },
  {
    num: '02',
    title: 'Shape the Opportunity',
    body: 'We combine strategy, creative thinking, and AI fluency to design a clear path forward \u2014 no jargon, no vague frameworks.',
  },
  {
    num: '03',
    title: 'Build the Next Form',
    body: 'We produce tangible outputs: prototypes, systems, visuals, strategic direction, or a clear plan you can act on immediately.',
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-60px' },
};

export default function Process() {
  return (
    <section id="process" className="py-24 md:py-36" data-testid="process-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="section-divider mb-12" />

        <motion.p className="section-number" {...fadeUp} data-testid="process-number">
          04 / Process
        </motion.p>
        <motion.h2
          className="section-title mt-3 mb-14 md:mb-20"
          {...fadeUp}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          data-testid="process-title"
        >
          Three Moves.
        </motion.h2>

        <div className="process-grid" data-testid="process-grid">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              className="process-step"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{
                duration: 0.7,
                delay: 0.12 * i,
                ease: [0.16, 1, 0.3, 1],
              }}
              data-testid={`process-step-${step.num}`}
            >
              <span className="process-num">{step.num}</span>
              <h3 className="process-step-title">{step.title}</h3>
              <p className="process-step-body">{step.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
